import { render, staticRenderFns } from "./ProductPreviewBox.vue?vue&type=template&id=6d5a64a2&scoped=true"
import script from "./ProductPreviewBox.vue?vue&type=script&lang=js"
export * from "./ProductPreviewBox.vue?vue&type=script&lang=js"
import style0 from "./ProductPreviewBox.vue?vue&type=style&index=0&id=6d5a64a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a64a2",
  null
  
)

export default component.exports